/* ==========================================================================
   JOURN-E THEME — cart-drawer.js (v4.0)
   AJAX cart drawer using Shopify's /cart.js API.
   Exposes window.JourneCart = { open, close, refresh } and window.JourneMoney
   so the bundle builder, sticky bar and any future feature can hook in.
   ========================================================================== */

(function () {
  'use strict';

  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-drawer__overlay');
  var cartTrigger = document.querySelector('[data-cart-trigger]');
  var cartCloseBtn = document.querySelector('.cart-drawer__close');
  var cartCount = document.querySelector('.header__cart-count');
  var itemsContainer = document.querySelector('.cart-drawer__items');
  var totalEl = document.querySelector('.cart-drawer__total-value');
  var freeShipEl = document.getElementById('DrawerFreeShip');
  /* Threshold comes from the theme setting (Rand) via window.JourneSettings —
     one source of truth with snippets/cart-drawer.liquid and main-cart.liquid. */
  var FREE_SHIP_THRESHOLD = ((window.JourneSettings && window.JourneSettings.shippingThreshold) || 1500) * 100;
  var FREE_SHIP_CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  /* ----- Money: use the store's real format (ZAR), with a Rand fallback ----- */
  function formatMoney(cents) {
    var fmt = (window.JourneSettings && window.JourneSettings.moneyFormat) || 'R {{amount}}';
    var amount = (cents / 100).toFixed(2);
    var thousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, thousands)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }
  window.JourneMoney = formatMoney;

  if (!drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    cartTrigger && cartTrigger.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    cartTrigger && cartTrigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  }

  cartTrigger && cartTrigger.addEventListener('click', function (e) {
    e.preventDefault();
    openDrawer();
    refreshCart();
  });
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* ----- Free-delivery reassurance line (kept in sync with AJAX cart) ----- */
  function updateFreeShip(totalCents) {
    if (!freeShipEl) return;
    if (totalCents >= FREE_SHIP_THRESHOLD) {
      freeShipEl.style.color = '';
      freeShipEl.innerHTML = FREE_SHIP_CHECK_SVG + ' Free delivery to anywhere in SA - ships from Johannesburg';
    } else {
      freeShipEl.style.color = 'var(--color-fg-muted)';
      freeShipEl.innerHTML = 'Add ' + formatMoney(FREE_SHIP_THRESHOLD - totalCents) + ' more for free delivery';
    }
  }

  /* ----- Render cart contents ----- */
  function renderCart(cart) {
    if (cartCount) {
      // v18: the count answers the tap with a small bump when something was added
      if (cart.item_count > (parseInt(cartCount.textContent, 10) || 0)) {
        cartCount.classList.remove('is-bump'); void cartCount.offsetWidth; cartCount.classList.add('is-bump');
      }
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    updateFreeShip(cart.total_price || 0);
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<h3>Your bag is empty</h3>' +
        '<p>Time to find your next ride.</p>' +
        '<a href="/collections/boards" class="btn btn--primary" style="margin-top:1.5rem;">Shop Boards</a>' +
        '</div>';
      if (totalEl) totalEl.textContent = formatMoney(0);
      var emptySaving = document.getElementById('DrawerSaving');
      if (emptySaving) emptySaving.hidden = true;
      return;
    }

    // v22.1: the sale lives in the real price, so the crossed-out price comes from the board's compare-at
    var compareAt = window.JourneCompareAt || {};
    var saving = 0;
    itemsContainer.innerHTML = cart.items.map(function (item) {
      var was = Math.max(item.original_line_price, (compareAt[item.variant_id] || 0) * item.quantity);
      saving += was - item.final_line_price;
      return (
        '<div class="cart-item" data-line-key="' + item.key + '">' +
          '<div class="cart-item__image">' +
            (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-item__body">' +
            '<a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
            '<div class="cart-item__row">' +
              '<div class="cart-item__qty">' +
                '<button type="button" data-qty-dec aria-label="Decrease">&minus;</button>' +
                '<input type="number" min="0" value="' + item.quantity + '" aria-label="Quantity" data-qty-input>' +
                '<button type="button" data-qty-inc aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="cart-item__price">' +
                (was > item.final_line_price ? '<del style="display:block;font-size:.78em;opacity:.55">' + formatMoney(was) + '</del>' : '') +
                formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
            (item.line_level_discount_allocations || []).map(function (d) {
              return '<div class="cart-item__variant" style="color:var(--color-success)">' + escapeHtml(d.discount_application.title) + ' -' + formatMoney(d.amount) + '</div>';
            }).join('') +
            '<button type="button" class="cart-item__remove" data-qty-remove>Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    var savingRow = document.getElementById('DrawerSaving');
    if (savingRow) {
      savingRow.hidden = saving <= 0;
      savingRow.querySelector('[data-drawer-saving]').textContent = formatMoney(saving);
    }
    bindLineEvents();
  }

  function bindLineEvents() {
    itemsContainer.querySelectorAll('.cart-item').forEach(function (row) {
      var key = row.dataset.lineKey;
      var input = row.querySelector('[data-qty-input]');
      var dec = row.querySelector('[data-qty-dec]');
      var inc = row.querySelector('[data-qty-inc]');
      var remove = row.querySelector('[data-qty-remove]');
      dec && dec.addEventListener('click', function () { updateLine(key, (parseInt(input.value, 10) || 1) - 1); });
      inc && inc.addEventListener('click', function () { updateLine(key, (parseInt(input.value, 10) || 0) + 1); });
      input && input.addEventListener('change', function () { updateLine(key, parseInt(input.value, 10) || 0); });
      remove && remove.addEventListener('click', function () { updateLine(key, 0); });
    });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(console.error);
  }

  function updateLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(console.error);
  }

  /* ----- Add-to-cart interception (any form with [data-product-form]) ----- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || 'Add to cart failed');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          renderCart(cart);
          openDrawer();
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Added ✓';
            setTimeout(function () { submitBtn.textContent = originalText; }, 1500);
          }
        })
        .catch(function (err) {
          console.error(err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          alert('Sorry - that item could not be added. Please try again.');
        });
    });
  });

  /* ----- Public API ----- */
  window.JourneCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };

  refreshCart();
})();
